"use no memo";

import { v4 as uuidv4 } from 'uuid';

import { OnAddItemType } from 'types/menu';
import { UpdateOrderAction } from '.';

export function setOrderRestaurantTip(
  tipAmount: number | string
): UpdateOrderAction {
  return (order) => ({
    tips: {
      ...order?.tips,
      restaurant_tip: {
        restaurant_tip_amount:
          typeof tipAmount === 'string' ? parseFloat(tipAmount) : tipAmount,
        restaurant_tip_percentage: null,
      },
    },
    pending_validation: true,
  });
}

export function setOrderManagedDeliveryTip(
  tipAmount: number | string
): UpdateOrderAction {
  return (order) => ({
    tips: {
      ...order?.tips,
      managed_delivery_tip: {
        managed_delivery_tip_amount:
          typeof tipAmount === 'string' ? parseFloat(tipAmount) : tipAmount,
        managed_delivery_tip_percentage: null,
      },
    },
    pending_validation: true,
  });
}

export function addItemToOrder(itemDetails: OnAddItemType): UpdateOrderAction {
  return (order) => ({
    items: [
      ...(order?.items ?? []),
      { ...itemDetails, tracking_id: itemDetails.tracking_id ?? uuidv4() },
    ],
    pending_validation: true,
  });
}

export function updateItemInOrder(
  itemDetails: OnAddItemType,
  itemIndex: number
): UpdateOrderAction {
  return (order) => ({
    items: [
      ...(order?.items?.slice(0, itemIndex) ?? []),
      itemDetails,
      ...(order?.items?.slice(itemIndex + 1) ?? []),
    ],
    pending_validation: true,
  });
}

export function removeItemFromOrder(itemDetails: {
  tracking_id?: string;
}): UpdateOrderAction {
  return (order) => {
    const itemIndex = order?.items?.findIndex(
      (orderItem) => orderItem.tracking_id === itemDetails.tracking_id
    );

    if (typeof itemIndex === 'undefined') {
      return {};
    }

    return {
      items: [
        ...(order?.items?.slice(0, itemIndex) ?? []),
        ...(order?.items?.slice(itemIndex + 1) ?? []),
      ],
      pending_validation: true,
    };
  };
}

export function removeItemsOrderById(
  itemIds: string[],
  triggerValidation = true
): UpdateOrderAction {
  return (order) => ({
    items: (order?.items ?? []).filter(
      (item) =>
        !(
          itemIds.includes(item.id) ||
          (item.sizeId && itemIds.includes(item.sizeId))
        )
    ),
    pending_validation: triggerValidation,
  });
}
